import { Grid } from '@material-ui/core';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Rating from '@material-ui/lab/Rating';
import "../Prestaciones/css/PrestacionCard.css";
import { MenuPrestacion } from "./MenuListPrestacion";
import GreenSwitch from "../ConfigPayroll/GreenSwitch";
import { GET_ALL_PRESTACIONES, UPDATE_PRESTACION_STATUS } from '../../Querys/prestaciones/querys';
import { useMutation } from "@apollo/client";
import { useState, useContext } from 'react';
import { ErrorAlert } from '../../alerts/errorAlert';
import { startglobalLoading } from '../../context/PrestacionesContext/Actions';
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';

export const PrestacionInfoCard = ({ prestacion }: any) => {
  //Controla si ESTA tarjeta está cargando
  const { dispatch } = useContext(PrestacionContext);
  const [isUpdating, setIsUpdating] = useState(false);

  const [updateStatus] = useMutation(UPDATE_PRESTACION_STATUS, {
    refetchQueries: [{ query: GET_ALL_PRESTACIONES }]
  });

  const updatePrestacionStatus = async (id: any) => {
    //Cuando se cambia el status
    startglobalLoading(dispatch);
    try {
      await updateStatus({
        variables: {
          id: id
        }
      });
    } catch (e) {
      ErrorAlert({ text: 'Error al actualizar' });
    } 
  }

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Grid>
      <Card className='containerCardPrestacion'>
        <CardContent className='contedorGeneralPrestacion'>
          <div className='containerInfoimg'>
            <div className='containerImagenPrestacion'>
              <img src={prestacion.URL} alt="prestacion" className='imgPrestacion' />
            </div>
            <div className='containertipoPrestacion'>
              <span className='tipoPrestacion'>{prestacion.TipoPrestacion}</span>
            </div>
          </div>
          <div className='infoCardPrestacion' >
            <div className='superiorPrestacion'>
              <div className='containertitlePrestacion'>
                <span className={prestacion.Titulo.length <= 30 ? 'titlePrestacionCard' : 'titlePrestacionCardMin'}>{prestacion.Titulo}</span>
              </div>
              <div className='infoCardControllers'>
                <div className='switchPrestacion' style={{ position: 'relative' }}>
                  <span className='actPrestacion'>{prestacion.Activa}</span>
                  <div className='switchPrestacion'>
                    <GreenSwitch updatePayrollStatus={updatePrestacionStatus}
                      id={prestacion.id}
                      status={prestacion.Activa}
                      disabled={isUpdating}
                    />
                  </div>
                </div>
                <div className='crudPrestacion'>
                  <MenuPrestacion
                    id={prestacion.id}
                  />
                </div>
              </div>
            </div>
            <div className={prestacion.Descripcion.length <= 300 ? 'containerDescripcionPrestacion' : 'containerDescripcionPrestacionMin'}>
              <span className='descripcionPrestacion'>{truncateText(prestacion.Descripcion, 120)}</span>
            </div>

            <div className='countersPrestacion'>
              <div className="containerPrestacion">
                <span className='countPrestacion'>{prestacion.countColaboradores}</span>
                <span className='meensajePrestacion'>Colaboradores</span>
              </div>
              <div className="pv-line"></div>

              <div className="containerPrestacion">
                <span className='countPrestacion'>{prestacion.countRestricciones}</span>
                <span className='meensajePrestacion'>Restricciones</span>

              </div>
              <div className="pv-line"></div>
              <div className="containerPrestacion">
                <span className='countPrestacion'>{prestacion.countComentarios}</span>
                <span className='meensajePrestacion'>Comentarios</span>
              </div>

            </div>
            {prestacion.promedio > 0 ?
              <div className='star'>
                <Rating name="half-rating-read" defaultValue={prestacion.promedio} precision={0.5} readOnly />
              </div>
              : <></>
            }
          </div>
        </CardContent>
      </Card>
    </Grid>
  )
}